import moment from 'moment-timezone';
import { displayMoment } from '../utils/displayTime';

/**
 * Activity logs print some values as a bare calendar date, and two different kinds of field end up
 * in that same shape:
 *
 * - `spaSigningDate` / `spaStampingDate` are legal calendar dates. A contract signed on the 18th
 *   was signed on the 18th for everyone, so these keep the configured zone.
 * - `approvedAt` / `cancelledAt` / `lastSoldAt` / `lastBookedAt` are real instants that merely
 *   happen to be rendered without a clock. Their calendar day has to be the viewer's, or a VN
 *   approval at 23:30 local reads as the previous day.
 *
 * The two are one line apart in `BookingActivities`, so they are expressed as two named functions
 * here: the difference is intentional and testable rather than an inconsistency.
 */

export const ACTIVITY_DATE_FORMAT = 'MMMM Do YYYY';

/** Legal calendar date — identical for every viewer, never converted. */
export function formatLegalDate(value) {
  return moment(value).format(ACTIVITY_DATE_FORMAT);
}

/** A true instant shown as a date only — the calendar day follows the viewer for VN. */
export function formatInstantAsDate(value, countryCode) {
  return displayMoment(value, countryCode).format(ACTIVITY_DATE_FORMAT);
}



// WEBPACK FOOTER //
// ./src/components/activityDateValue.js